/** 页面信息 */
const page = new (function () {
  this.title = '执法人员查询案件信息'
  this.icon = 'iconfont iconicon_group'
  this.name = 'query_person'
  /**菜单编号 */
  this.code = 'penalize_person_info'
  /**菜单别名 */
  this.aliasName = 'menu'
  /**路由地址 */
  this.path = '/query/person'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
